module.exports = `${require.publicPath}logo.9322f8eb.png`;